import { CSSObject } from '@mui/material';

import { grey } from '../../options/palette';

const hue = 500;

const disabled: CSSObject = {
  // Contained Styling
  contained: {
    '&.Mui-disabled': {
      pointerEvents: 'none',

      background: grey[hue],
      backgroundColor: grey[hue],
      borderColor: grey[hue],
      color: '#FFF',

      opacity: 0.5
    }
  },

  // Outlined Styling
  outlined: {
    '&.Mui-disabled': {
      pointerEvents: 'none',

      background: 'transparent',
      backgroundColor: 'transparent',
      borderColor: grey[hue],
      color: grey[hue],

      opacity: 0.5
    }
  },

  // Text Styling
  text: {
    '&.Mui-disabled': {
      pointerEvents: 'none',

      background: 'transparent',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: grey[hue],

      opacity: 0.5
    }
  }
};

export default disabled;
